<div class="container-fluid">
    <div class="row justify-content-center mt-5">
      <header class="header">
        <h3 class="text-center">Lamination</h3>
      </header>
      <div class="col-lg-12">
        <div class="card">

          <div class="row mb-2 mt-2">
            <div class="col-md-2 mt-3 offset-md-10">
            <button class="btn btn-outline-primary btn-sm"><a routerLinkActive="router-link-active" routerLink="/laminationProdTable">
              <span class="nav-menu-item-title"> 
                  <i class="feather icon-tag ng-star-inserted"></i>Lamination Records</span>
          </a></button>
          </div>
          </div>
          <div class="card-body">
            <form [formGroup]="tempLaminationForm" (ngSubmit)="tempLamination()" (keydown.enter)="$event.preventDefault()">
              <div class="row mb-3">
  
                <!-- Ticket Number Selector -->
                <div class="col-md-2 mb-3">
                  <label for="ticketNo" class="form-label">Ticket Number</label>
                  <select formControlName="ticketNo" id="ticketNo" class="form-control" (change)="onTicketSelect($event)" *ngIf="tickets.length > 0">
                    <option value="">Select Ticket</option>
                    <option *ngFor="let ticket of tickets" [value]="ticket.ticketno">{{ ticket.ticketno }}</option>
                  </select>
                  <!-- <div *ngIf="tickets.length === 0">Loading tickets...</div> -->
                </div>
  
               
       <!-- Date Input -->
       <div class="col-md-2 mb-3">
        <label for="date" class="form-label">Date</label>
        <input type="date" id="date" class="form-control" placeholder="Enter Date" formControlName="date" />
      </div>


      <div class="col-md-2 mb-3">
        <label class="form-label">Shift</label>
<select class="form-select" formControlName="shift" required>
    <option value="" disabled selected>Select Shift</option>
    <option value="A">A</option>
    <option value="B">B</option>
    <option value="C">C</option>
    <option value="A 12">A 12</option>
    <option value="B 12">B 12</option>
</select>
    </div>

    <div class="col-md-2 mb-3">
      <label for="machine" class="form-label">Machine</label>
      <select class="form-select" formControlName="machine" required>
          <option value="" disabled selected>Select Machine</option>
          <!-- <option value="P1-ROTO">P1-ROTO</option>
          <option value="P2-ROTO">P2-ROTO</option>
          <option value="P3-ROTO">P3-ROTO</option>
          <option value="P4-ROTO">P4-ROTO</option>
          <option value="P5-ROTO">P5-ROTO</option>
          <option value="P6-ROTO">P6-ROTO</option> -->
          <option value="LM 1">LM 1</option>
          <option value="LM 2">LM 2</option>
      </select>
    </div>
    

    <div class="col-md-2 mb-3">
      <label for="operator" class="form-label">Operator</label>
      <select class="form-select" formControlName="operator" id="operator" >
          <option value="" disabled selected>Select Operator</option>
          <!-- <option value="Chandrakan" selected="">Chandrakan</option>
          <option value="ASAMOAH">ASAMOAH</option>
          <option value="BERTHA">BERTHA</option>
          <option value="Brigh">Brigh</option>
          <option value="Chandrakan">Chandrakan</option>
          <option value="Daniel">Daniel</option>
          <option value="Deepak">Deepak</option>
          <option value="DEEPAK B">DEEPAK B</option> -->
           <option value="SURESH BHOJANAE" selected="">SURESH BHOJANAE</option>
                    <option value="MANGESH SHELAR">MANGESH SHELAR</option>
                    <option value="VAHID KHOT">VAHID KHOT</option>
                    <option value="VIGNESH DESAI">VIGNESH DESAI</option>
                    <option value="RAGHAVENDRA SAFI">RAGHAVENDRA SAFI</option>
                    <option value="GAJENDRA PRATAP SINGH">GAJENDRA PRATAP SINGH</option>
                    <option value="PRASHANT DAS">PRASHANT DAS</option>
                    <option value="AJAY KUMAR">AJAY KUMAR</option>

                    <option value="NIRANJAN YADAV">NIRANJAN YADAV</option>
                    <option value="MAYUR CHAVAN">MAYUR CHAVAN</option>
                    <option value="SURAJ SINGH CHAUHAN">SURAJ SINGH CHAUHAN</option>
                    <option value="VIKRAM SINGH">VIKRAM SINGH</option>
                    <option value="SHIVAM BHARDWAJ">SHIVAM BHARDWAJ</option>
                    <option value="SHIVAM KUMAR">SHIVAM KUMAR</option>
                    <option value="SACHIN KOLHE">SACHIN KOLHE</option>
                    <option value="PRIYANSHU VERMA">PRIYANSHU VERMA</option>
                    <option value="RANJAN SETHI">RANJAN SETHI</option>
                    <option value="SURENDRA PAL">SURENDRA PAL</option>
                    <option value="DHEERAJ">DHEERAJ</option>
                    <option value="DELE- OLANREWAJU SAHEED">DELE- OLANREWAJU SAHEED</option>
                    <option value="WASIU KAYODE BUSARI">WASIU KAYODE BUSARI</option>
                    <option value="IBRAHIM OLADIMEJI">IBRAHIM OLADIMEJI</option>
                    <option value="FOLAYINKA KILANI">FOLAYINKA KILANI</option>

                     <option value="ABIODUN OLALEKAN ADEBIJI">ABIODUN OLALEKAN ADEBIJI</option>
                      <option value="DANIEL OLUWADAMILARE">DANIEL OLUWADAMILARE</option>
                    <option value="DEEPAK SHARMA">DEEPAK SHARMA</option>
                    <option value="SANJAY CHAURASIYA">SANJAY CHAURASIYA</option>
                    <option value="VIVEK KUMAR">VIVEK KUMAR</option>
                    <option value="ARUN">ARUN</option>
                    <option value="SOLOMAN">SOLOMAN</option>
                    <option value="ENOCH">ENOCH</option>
                    <option value="FRANCISCA">FRANCISCA</option>
                    <option value="PATIENCE">PATIENCE</option>
                    <option value="SAMUEL">SAMUEL</option>
                    <option value="BRUCE">BRUCE</option>
                    <option value="MARY">MARY</option>
                    <option value="ROMEO">ROMEO</option>
                    <option value="REUBEN">REUBEN</option>
                    <option value="MAWUENA">MAWUENA</option>

                    <!-- Newly added names -->
    <option value="JOEL">JOEL</option>
    <option value="MARK">MARK</option>
    <option value="DANIEL">DANIEL</option>
    <option value="ABBEY">ABBEY</option>
    <option value="KING">KING</option>
    <option value="FOSTER">FOSTER</option>
    <option value="JUDITH">JUDITH</option>
    <option value="OLIVIA">OLIVIA</option>
    <option value="BEATRICE">BEATRICE</option>
    <option value="VERA">VERA</option>
    <option value="VIKAS">VIKAS</option>
    <option value="ARUN">ARUN</option>
    <option value="AKIN">AKIN</option>
    <option value="SAFIATU">SAFIATU</option>
    <option value="PATRICIA">PATRICIA</option>
    <option value="BERNICE">BERNICE</option>

        <option value="STEVEN">STEVEN</option>
    <option value="OSMAN">OSMAN</option>
    <option value="EMMANUEL">EMMANUEL</option>
    <option value="MAJEED">MAJEED</option>
    <option value="RAM KISHAN">RAM KISHAN</option>
    <option value="BASIT">BASIT</option>
    <option value="SAMAD">SAMAD</option>
    <option value="HARSHA">HARSHA</option>

   <option value="VISHAL">VISHAL</option>
   <option value="ADEMOLA">ADEMOLA</option>
   <option value="ASHISH">ASHISH</option>
   <option value="DAVID AWONARO">DAVID AWONARO</option>
     <option value="DHANJAY">DHANJAY</option>
      <option value="VINAY">VINAY</option>
       <option value="VINAY KUMAR SINGH">VINAY KUMAR SINGH</option>
    <option value="KOLA">KOLA</option>
      </select>
    </div>



      <!-- Width Input -->
      <!-- <div class="col-md-4 mb-3">
        <label for="width" class="form-label">Enter Width</label>
        <input type="text" id="width" class="form-control" placeholder="Enter Width" formControlName="width" />
      </div> -->
      <!-- <div class="col-md-4 mb-3">
          <label for="std" class="form-label">Enter Std</label>
          <input type="text" id="std" class="form-control" placeholder="Enter Std" formControlName="std" />
        </div> -->

      <!-- Reference Number Input -->
      <div class="col-md-2 mb-3">
        <label for="refNo" class="form-label">Reference Number</label>
        <input type="text" id="refNo" class="form-control" placeholder="Enter Reference Number" formControlName="refNo" />
      </div>

      <!-- PO Number Input -->
      <!-- <div class="col-md-4 mb-3">
        <label for="poNumber" class="form-label">PO Number</label>
        <input type="text" id="poNumber" class="form-control" placeholder="Enter PO Number" formControlName="poNumber" />
      </div> -->


      <div class="col-md-12 mb-1 mt-2">
        <label for="combinedMaterials" class="form-label">Production</label></div>

         <!-- Job Name Input -->
         <div class="col-md-4 mb-3">
          <label for="jobName" class="form-label">Job Name</label>
          <input type="text" id="jobName" class="form-control" placeholder="Enter Job Name" formControlName="jobName" />
        </div>
      
      <!-- Client Name Input -->
      <div class="col-md-4 mb-3">
        <label for="clientName" class="form-label">Client Name</label>
        <input type="text" id="clientName" class="form-control" placeholder="Enter Client Name" formControlName="clientName" />
      </div>

      <div class="col-md-4 mb-3">
        <label for="JCO" class="form-label">JCO</label>
              <input type="text" formControlName="jco" class="form-control" placeholder="JCO" />
      </div>





      <div class="col-md-12 mb-1 mt-2">
        <label for="combinedMaterials" class="form-label">Substrate 1</label></div>


                <!-- <div class="col-md-2 mb-3">
                  <label for="material" class="form-label">Material 1</label>
                  <input type="text" formControlName="material" class="form-control" placeholder="Material" />
                </div> -->
                <div class="col-md-2 mb-3">
  <label for="material" class="form-label">Material 1</label>
  <select class="form-select" formControlName="material" id="material">
    <option value="" disabled selected>Select Material</option>
    <option value="BOPP PRINTED">BOPP PRINTED</option>
    <option value="BOPP CLEAR">BOPP CLEAR</option>
    <option value="BOPP MET">BOPP MET</option>
    <option value="BOPP MATT">BOPP MATT</option>
    <option value="BOPP PEARL">BOPP PEARL</option>
    <option value="PET PRINTED">PET PRINTED</option>
    <option value="PET CLEAR">PET CLEAR</option>
    <option value="PET MET">PET MET</option>
    <option value="PET MATT">PET MATT</option>
    <option value="LDPE WHITE">LDPE WHITE</option>
    <option value="LDPE CLEAR">LDPE CLEAR</option>
    <option value="CPP CLEAR">CPP CLEAR</option>
    <option value="CPP MET">CPP MET</option>
    <option value="ALU. FOIL">ALU. FOIL</option>
    <option value="BASE-2PLY (PET+FOIL)">BASE-2PLY (PET+FOIL)</option>
    <option value="BASE-2PLY (PET+ MET PET)">BASE-2PLY (PET+ MET PET)</option>
    <option value="BASE-2PLY (PET+LD)">BASE-2PLY (PET+LD)</option>
    <option value="BASE-2PLY (FOIL + LDPE)">BASE-2PLY (FOIL + LDPE)</option>
    <option value="BASE-2PLY">BASE-2PLY</option>
    <option value="BASE-3PLY">BASE-3PLY</option>
  </select>
</div>

                <!-- <div class="col-md-4 mb-3">
                  <label for="Thickness" class="form-label">Thickness</label>
                        <input type="text" formControlName="thickness" class="form-control" placeholder="Thickness" />
                </div> -->



                <div class="col-md-2 mb-3">
                  <label for="Width" class="form-label">Width/Size</label>
                        <input type="text" formControlName="width" class="form-control" placeholder="Width" />
                </div>
                <div class="col-md-2 mb-3">
                  <label for="Thickness" class="form-label"> Thickness</label>
                        <input type="text" formControlName="thicknessMat" class="form-control" placeholder="Thickness" />
                </div>
                <div class="col-md-2 mb-3">
                  <label for="I/P " class="form-label">I/P QTY</label>
                        <input type="text" formControlName="ip1" class="form-control" placeholder="I/P " />
                </div>

                <!-- <div class="col-md-2 mb-3">
                  <label for="O/P " class="form-label">O/P QTY</label>
                        <input type="text" formControlName="op1" class="form-control" placeholder="O/P QTY " />
                </div>
                <div class="col-md-2 mb-3">
                  <label for="JCO " class="form-label">JCO</label>
                        <input type="text" formControlName="jco1" class="form-control" placeholder="JCO " />
                </div>
                <div class="col-md-2 mb-3">
                  <label for="No. of Coils " class="form-label">No. of Coils</label>
                        <input type="text" formControlName="coils1" class="form-control" placeholder="No. of Coils " />
                </div>
                <div class="col-md-2 mb-3">
                  <label for="No. of Ups " class="form-label">No. of Ups</label>
                        <input type="text" formControlName="ups1" class="form-control" placeholder="No. of Ups " />
                </div> -->



                <div class="col-md-12 mb-1 mt-2">
                  <label for="combinedMaterials" class="form-label">Substrate 2</label></div>

                <!-- <div class="col-md-2 mb-3">
                  <label for="material" class="form-label">Material 2</label>
                  <input type="text" formControlName="materialLam" class="form-control" placeholder="Material" />
                </div> -->
                <div class="col-md-2 mb-3">
  <label for="materialLam" class="form-label">Material 2</label>
  <select class="form-select" formControlName="materialLam" id="material">
    <option value="" disabled selected>Select Material</option>
    <option value="BOPP PRINTED">BOPP PRINTED</option>
    <option value="BOPP CLEAR">BOPP CLEAR</option>
    <option value="BOPP MET">BOPP MET</option>
    <option value="BOPP MATT">BOPP MATT</option>
    <option value="BOPP PEARL">BOPP PEARL</option>
    <option value="PET PRINTED">PET PRINTED</option>
    <option value="PET CLEAR">PET CLEAR</option>
    <option value="PET MET">PET MET</option>
    <option value="PET MATT">PET MATT</option>
    <option value="LDPE WHITE">LDPE WHITE</option>
    <option value="LDPE CLEAR">LDPE CLEAR</option>
    <option value="CPP CLEAR">CPP CLEAR</option>
    <option value="CPP MET">CPP MET</option>
    <option value="ALU. FOIL">ALU. FOIL</option>
    <option value="BASE-2PLY (PET+FOIL)">BASE-2PLY (PET+FOIL)</option>
    <option value="BASE-2PLY (PET+ MET PET)">BASE-2PLY (PET+ MET PET)</option>
    <option value="BASE-2PLY (PET+LD)">BASE-2PLY (PET+LD)</option>
    <option value="BASE-2PLY (FOIL + LDPE)">BASE-2PLY (FOIL + LDPE)</option>
    <option value="BASE-2PLY">BASE-2PLY</option>
    <option value="BASE-3PLY">BASE-3PLY</option>
  </select>
</div>
                

                <div class="col-md-2 mb-3">
                  <label for="Width" class="form-label">Width/Size</label>
                        <input type="text" formControlName="width2" class="form-control" placeholder="Width" />
                </div>
                <div class="col-md-2 mb-3">
                  <label for="Thickness" class="form-label"> Thickness</label>
                        <input type="text" formControlName="thicknessMat2" class="form-control" placeholder="Thickness" />
                </div>

                <div class="col-md-2 mb-3">
                  <label for="I/P " class="form-label">I/P QTY</label>
                        <input type="text" formControlName="ip2" class="form-control" placeholder="I/P " />
                </div>

               <!-- <div class="col-md-2 mb-3">
                  <label for="O/P " class="form-label">O/P QTY</label>
                        <input type="text" formControlName="op2" class="form-control" placeholder="O/P QTY " />
                </div>
                <div class="col-md-2 mb-3">
                  <label for="JCO " class="form-label">JCO</label>
                        <input type="text" formControlName="jco2" class="form-control" placeholder="JCO " />
                </div>
                <div class="col-md-2 mb-3">
                  <label for="No. of Coils " class="form-label">No. of Coils</label>
                        <input type="text" formControlName="coils2" class="form-control" placeholder="No. of Coils " />
                </div>
                <div class="col-md-2 mb-3">
                  <label for="No. of Ups " class="form-label">No. of Ups</label>
                        <input type="text" formControlName="ups2" class="form-control" placeholder="No. of Ups " />
                </div> -->
                

                <!-- <div class="col-md-3 mb-3">
                  <label for="Thick" class="form-label">Thick</label>
                        <input type="text" formControlName="thick" class="form-control" placeholder="Thick" />
                </div> -->





                <div class="col-md-12 mb-1 mt-2">
                  <label for="combinedMaterials" class="form-label">Output</label></div>

                  <div class="col-md-3 mb-3">
                    <label for="Output" class="form-label">Material Total Output </label>
                          <input type="text" formControlName="output" class="form-control" placeholder="Output" />
                  </div>
                 

                <div class="col-md-12 mb-1 mt-2">
                  <label for="combinedMaterials" class="form-label">Wastage</label></div>

                  <!-- <div class="col-md-3 mb-3">
                    <label for="Output" class="form-label">Output Qty</label>
                          <input type="text" formControlName="output" class="form-control" placeholder="Output" />
                  </div> -->

                  <div class="col-md-2 mb-3">
                    <label for=" Plain Wastage" class="form-label"> Plain Wastage</label>
                          <input type="text" formControlName="plain" class="form-control" placeholder=" Plain Wastage" />
                  </div>
                  <div class="col-md-2 mb-3">
                    <label for="Printed  Wastage" class="form-label"> Printed Wastage</label>
                          <input type="text" formControlName="printed" class="form-control" placeholder=" Printed Wastage" />
                  </div>
                  <div class="col-md-2 mb-3">
                    <label for=" Laminated Wastage" class="form-label"> Laminated Wastage</label>
                          <input type="text" formControlName="laminated" class="form-control" placeholder=" Laminated Wastage" />
                  </div>
                  <div class="col-md-2 mb-3">
                    <label for=" Other Wastage" class="form-label"> Other Wastage</label>
                          <input type="text" formControlName="otherWaste" class="form-control" placeholder=" Other Wastage" />
                  </div>
                  <div class="col-md-2 mb-3">
                    <label for=" Total Wastage" class="form-label"> Total Wastage</label>
                          <input type="text" formControlName="totalWaste" class="form-control" placeholder=" Total Wastage" />
                  </div>
  
                  <!-- <div class="col-md-3 mb-3">
                    <label for="Output Wastage" class="form-label">Output Wastage</label>
                          <input type="text" formControlName="job" class="form-control" placeholder="Output Wastage" />
                  </div> -->

                  


                  <div class="col-md-12 mb-1 mt-2">
                    <label for="combinedMaterials" class="form-label">Adhesive Used</label></div>
                    <div class="col-md-3 mb-3">
                    <label for="Adhesive" class="form-label">Adhesive A (NCO)</label>
                        <input type="text" formControlName="mix" class="form-control" placeholder="Adhesive A" />
                </div>
                <div class="col-md-3 mb-3">
                  <label for="Hardner" class="form-label">Hardner B (OH)</label>
                        <input type="text" formControlName="fresh" class="form-control" placeholder="Hardner B" />
                </div>
                <div class="col-md-3 mb-3">
                  <label for="Return" class="form-label">Total</label>
                        <input type="text" formControlName="returnn" class="form-control" placeholder="Total Adh" />
                </div>
                <div class="col-md-3 mb-3">
                  <label for="Consumed" class="form-label">I/O MTR</label>
                        <input type="text" formControlName="consumed" class="form-control" placeholder="I/O MTR" />
                </div>

  

                    <!-- <div class="col-md-12 mb-1 mt-2">
                      <label for="combinedMaterials" class="form-label">Material Size & Trim Wastage</label></div> -->

                      <!-- <div class="col-md-3 mb-3">
                        <label for="EA" class="form-label">Coils</label>
                              <input type="text" formControlName="ea" class="form-control" placeholder="Coils" />
                      </div>
                      <div class="col-md-3 mb-3">
                        <label for="IPA" class="form-label">Coil Size</label>
                              <input type="text" formControlName="ipa" class="form-control" placeholder="Coil Size" />
                      </div>
                      <div class="col-md-3 mb-3">
                        <label for="BUTONOL" class="form-label">Size</label>
                              <input type="text" formControlName="butonol" class="form-control" placeholder="Size" />
                      </div>
                      <div class="col-md-3 mb-3">
                        <label for="TOLUNE" class="form-label">Trim</label>
                              <input type="text" formControlName="tolune" class="form-control" placeholder="Trim" />
                      </div>
                      <div class="col-md-3 mb-3">
                        <label for="Others" class="form-label">Kgs</label>
                              <input type="text" formControlName="otherSol" class="form-control" placeholder="Kgs" />
                      </div>
                      <div class="col-md-3 mb-3">
                        <label for="Total" class="form-label">Mat %</label>
                              <input type="text" formControlName="totalSol" class="form-control" placeholder="%" />
                      </div> -->






                <!-- Dynamic Combined Materials Section -->
                <!-- <div class="col-md-12 mb-3">
                  <label for="combinedMaterials" class="form-label">Combined Materials</label>
                  <div formArrayName="combinedMaterials">
                    <div *ngFor="let material of getCombinedMaterialsControls(); let i = index" [formGroupName]="i" class="row">
                      <div class="col-md-2">
                        <label for="material" class="form-label">Material</label>
                        <input type="text" formControlName="material" class="form-control" placeholder="Material" />
                      </div>
                      <div class="col-md-2">
                        <input type="text" formControlName="density" class="form-control" placeholder="Density" />
                      </div>
                      <div class="col-md-2">
                        <input type="text" formControlName="gsm" class="form-control" placeholder="GSM" />
                      </div>
                      <div class="col-md-2">
                        <input type="text" formControlName="matRequired" class="form-control" placeholder="Mat Required" />
                      </div>
                      <div class="col-md-2">
                        <input type="text" formControlName="netRm" class="form-control" placeholder="Net RM" />
                      </div>
                      <div class="col-md-2">
                        <label for="Process" class="form-label">Process</label>
                        <input type="text" formControlName="process" class="form-control" placeholder="Process" />
                      </div>
                      <div class="col-md-2">
                        <label for="Thickness" class="form-label">Thickness</label>
                        <input type="text" formControlName="thickness" class="form-control" placeholder="Thickness" />
                      </div>
                      <div class="col-md-2">
                        <input type="text" formControlName="waste" class="form-control" placeholder="Waste" />
                      </div>
                      <div class="col-md-2">
                        <label for="Width" class="form-label">Width/Size</label>
                        <input type="text" formControlName="width" class="form-control" placeholder="Width" />
                      </div>
                      <div class="col-md-2">
                        <button type="button" class="btn btn-danger" (click)="removeMaterial(i)">Remove</button>
                      </div>
                    </div>
                  </div>
  
                 
                  <button type="button" class="btn btn-outline-primary" (click)="addMaterial()">Add Material</button>
                </div> -->
  
              </div>
  
              <!-- Submit Button -->
              <div class="text-end">
                <button type="submit" class="btn btn-outline-dark">Submit</button>
              </div>
            </form>
          </div><!-- end card-body -->
        </div><!-- end card -->
      </div><!-- end col -->
    </div><!-- end row -->
  </div><!-- end container -->
  